"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESTATUS_SMS_SALIENTE = void 0;
exports.ESTATUS_SMS_SALIENTE = {
    CANCELADO: 'CANCELADO',
    CANCEL: 'CANCEL',
    ENTREGADO: 'delivered',
    EN_PROCESO: 'sending',
    ENVIADO: 'sent',
    NO_ENTREGADO: 'undelivered',
    NO_ENVIADO: 'notsent',
    PAUSADO: 'PAUSADO',
    PAUSED: 'PAUSED',
    PENDIENTE: 'SEND',
};
